import { Component, input, InputSignal } from '@angular/core';

@Component({
    selector: 'app-table-cell',
    templateUrl: './table-cell.component.html',
    standalone: true,
    host: {
        class: 'overflow-hidden',
        '[style.min-width]': 'minWidth()'
    }
})
export class TableCellComponent {
    public width: InputSignal<string> = input('1fr');
    public minWidth: InputSignal<string> = input('100px');
}
